// Header controls: example picker, Run button, and the seed / max-time inputs
// that parameterize a run.

interface ToolbarProps {
  examples: string[];
  example: string;
  seed: number;
  maxTime: number;
  onExampleChange(name: string): void;
  onSeedChange(seed: number): void;
  onMaxTimeChange(maxTime: number): void;
  onRun(): void;
}

export function Toolbar({
  examples,
  example,
  seed,
  maxTime,
  onExampleChange,
  onSeedChange,
  onMaxTimeChange,
  onRun,
}: ToolbarProps) {
  return (
    <header>
      <h1>STM&nbsp;Lang Playground</h1>
      <label>
        example{" "}
        <select value={example} onChange={(e) => onExampleChange(e.target.value)}>
          {examples.map((name) => (
            <option key={name} value={name}>
              {name}
            </option>
          ))}
        </select>
      </label>
      <button onClick={onRun}>Run ▶</button>
      <div className="spacer" />
      <label>
        seed{" "}
        <input
          type="number"
          value={seed}
          onChange={(e) => onSeedChange(Number(e.target.value))}
        />
      </label>
      <label>
        max&nbsp;time{" "}
        <input
          type="number"
          step="0.05"
          value={maxTime}
          onChange={(e) => onMaxTimeChange(Number(e.target.value))}
        />
      </label>
    </header>
  );
}
